import React from 'react';

const NotiIcon = ({ className }) => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path fillRule="evenodd" clipRule="evenodd" d="M8.30911 3.68194L0.109113 17.7999C-0.199887 18.3319 0.184113 18.9999 0.800113 18.9999H17.2001C17.8161 18.9999 18.2001 18.3319 17.8911 17.7999L9.69111 3.68194C9.38311 3.15094 8.61711 3.15094 8.30911 3.68194Z" fill="white"/>
    <path d="M9.9001 7H8.1001V13H9.9001V7Z" fill="#00847F"/>
    <path d="M9 16.8259C9.69036 16.8259 10.25 16.2663 10.25 15.5759C10.25 14.8856 9.69036 14.3259 9 14.3259C8.30964 14.3259 7.75 14.8856 7.75 15.5759C7.75 16.2663 8.30964 16.8259 9 16.8259Z" fill="#00847F"/>
  </svg>
);

export default NotiIcon;
